import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConsultationProvider } from "@/components/forms/ConsultationDialog";
import { Layout } from "@/components/layout/Layout";

import Home from "@/pages/Home";
import HowWeWork from "@/pages/HowWeWork";
import Solutions from "@/pages/Solutions";
import WhatChanged from "@/pages/WhatChanged";
import About from "@/pages/About";
import BillingBreakthrough from "@/pages/BillingBreakthrough";
import Resources from "@/pages/Resources";
import NotFound from "@/pages/NotFound";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function App() {
  return (
    <BrowserRouter>
      <ConsultationProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/what-changed" element={<WhatChanged />} />
            <Route path="/billing-breakthrough" element={<BillingBreakthrough />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" />
      </ConsultationProvider>
    </BrowserRouter>
  );
}

export default App;
